import { RootContext } from "@/contexts/rootContext";
import { useFCMRedirectListener } from "@/hooks/useFCMRedirectListener";
import { useFCMToken } from "@/hooks/useFCMToken";
import { STORAGE_KEY } from "@/utils/enum";
import { useContext, useEffect } from "react";
import EnableNotificationGuide from "./EnableNotificationGuide";

export default function NotificationPermissionManager() {
  const { state } = useContext(RootContext);
  const uid = state?.user?.uid;
  useFCMRedirectListener();

  const { permission, requestNotificationPermission } = useFCMToken();

  useEffect(() => {
    const isRequestFirstTime = localStorage.getItem(STORAGE_KEY.IS_REQUEST_FIRST_TIME);

    if (isRequestFirstTime !== "true") return;

    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    if (standalone) {
      const handler = async () => {
        requestNotificationPermission(uid);
        window.removeEventListener("click", handler);
      };

      window.addEventListener("click", handler);

      return () => window.removeEventListener("click", handler);
    } else {
      requestNotificationPermission(uid);
    }
  }, []);

  return <EnableNotificationGuide permission={permission} />;
}
